import { map } from 'rxjs/operators';
import { Component, OnInit, OnDestroy, Input,
  SimpleChanges, OnChanges, ViewChild } from '@angular/core';
  import { MatSelectionListChange } from '@angular/material';
  import { BehaviorSubject, Subscription } from 'rxjs';
import { IChartConfig, IChartData, IChartDataset } from '@base/interfaces';
import { COLORS } from '@base/utils';
import { LoggerService } from '@base/logger/logger.service';
import { Chart } from 'chart.js';
import * as _ from 'lodash';
import { ICompany } from '@base/company/company.structures';
import { AppService } from '@base/app.service';
import { PaginationInstance } from 'ngx-pagination';
import { CompanyService } from '@base/company/company.service';

interface ICompanyListItem {
  name: string;
  selected: boolean;
}

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.sass']
})
export class ChartComponent implements OnInit, OnDestroy, OnChanges {
  private options: {};
  private groupedDataSource = {};
  private customersLog = [];
  private subscriptions: Subscription[];
  private datasets: IChartDataset[];
  private auxDatasets: IChartDataset[];
  private companiesAllowed: ICompany[];

  chart1: any;
  chart2: any;

  @Input() dataSource: [];
  @Input() data: IChartData;
  @Input() type: string;
  @Input() day: object;

  chartInfo: IChartConfig;
  gettingCompanies = true;
  listCompanies: ICompanyListItem[];
  filteredCustomersLog = [];
  tableHeaders = [];
  summaryData: [];

  @ViewChild ('matcompanies') public matcompanies;
  checkedAll = true;
  checkedAllSubject = new BehaviorSubject<boolean>(this.checkedAll);

  totalConnections = undefined;

  p1 = 1;
  p2 = 1;
  filterCustomers = '';
  filterCompanies = '';

  constructor(
    private loggerService: LoggerService,
    private companyService: CompanyService,
  ) {
    this.chart1 = [];
    this.chart2 = [];
    this.summaryData = [];
    this.listCompanies = [];
    this.subscriptions = [];
    this.datasets = [];
    this.auxDatasets = [];

    this.companiesAllowed = [];

    // actualizar la lista de empresas que puede ver el lider(todas) o analista(filtradas)
    const currentCompaniesSubscription: Subscription = this.companyService.observeCompanies().subscribe(
      (companies: ICompany[]) => {
        this.companiesAllowed = companies;
      },
      err => console.error(`Ocurrio un error: ${err.message}`)
    );
    this.subscriptions = [...this.subscriptions, currentCompaniesSubscription];
  }

  ngOnInit() {
    // escuchar cambio de activacion/desactivacion de todas las empresas (select all)...
    const checkedSubscription = this.checkedAllSubject.subscribe((selected) => {
      // console.log('checkedAllSubject');
    });

    // escuchar los cambios de seleccion de empresas
    const matCompaniesSubscription =
      this.matcompanies.selectionChange.subscribe(
        (s: MatSelectionListChange) => {
          // crear nueva estructura solo con las empreas seleccionadas...
          const selectedCompanies = {
            summary: [] as ICompanyListItem[],
            chart1: [],
            chart2: [],
          };
          const company = s.option.value['name'];
          const selected = s.option.selected;
          const auxTotals = [...this.data.datasets[0].data];

          if (!selected) {
            const objIndex = this.auxDatasets.findIndex((obj => obj.label === company));
            const borrado = this.auxDatasets.splice(objIndex, 1);

            // calcular los nuevos totales...
            auxTotals.map((value: number, i) => {
              auxTotals[i] = (auxTotals[i] - borrado[0].data[i]);
            });
          } else if (selected) {
            const objIndex = this.datasets.findIndex((obj => obj.label === company));

            // calcular los nuevos totales...
            auxTotals.map((value: number, i) => {
              auxTotals[i] = (auxTotals[i] + this.datasets[objIndex].data[i]);
            });

            // calcular valores del grafico #2...
            this.auxDatasets = [...this.auxDatasets, this.datasets[objIndex]];
          }

          this.data.datasets[0].data = auxTotals;
          this.chart1.update();

          this.chart2['data']['datasets'] = this.auxDatasets;
          this.chart2.update();

          // actualiza el resumen...
          const companiesSelected = s.option.selectionList.selectedOptions.selected;
          companiesSelected.map((item) => {
            selectedCompanies.summary = [...selectedCompanies.summary, {name: item.value['name'], selected: true}];
          });
          this.summaryData = this.mergeSelectedCompanies(selectedCompanies.summary) as [];

          this.checkedAll = (!s.option.selected) ? false : this.checkedAll;
        }
      );
    this.subscriptions = [...this.subscriptions, checkedSubscription, matCompaniesSubscription];

    this.options = {
      responsive: true,
      title: {
        display: false,
        text: 'Grafico Tipo Linea'
      },
      legend: {
        display: false
     },
      tooltips: {
        mode: 'index',
        intersect: false,
      },
      // hover: {
      //   mode: 'nearest',
      //   intersect: true,
      // },
      elements: {
        point: {
          pointStyle: 'circle'
        }
      },
      scales: {
        xAxes: [{
          // type: 'time',
          display: true,
          ticks: {
            callback: function(value, index, valuess) {
              return value + ' Hrs.';
            }
          },
          scaleLabel: {
            display: true,
            labelString: 'Horario de conexiones'
          }
        }],
        yAxes: [{
          display: true,
          ticks: {
            beginAtZero: true,
            // callback: function(value, index, values) {
            //   return '$' + value;
            // }
          },
          scaleLabel: {
            display: true,
            labelString: 'Cantidad'
          }
        }]
      }
    };
  }

  ngOnDestroy() {
    this.subscriptions.map((tunnel: Subscription) => tunnel.unsubscribe());
  }

  ngOnChanges(changes: SimpleChanges) {
    this.chartInfo = {
      type: this.type,
      data: this.data,
      options: this.options
    };

    if (typeof this.chartInfo.data !== 'undefined') {
      // inicializar...
      this.totalConnections = [...this.data.datasets[0].data];
      this.chart1 = new Chart('chart-object1', this.chartInfo);

      // preparar la informacion completa para generar el GRAFICO #1 (R E S U  M E N)
      this.loggerService.getCompanyCustomersLog(this.day).subscribe((logs) => {
        const auxLogs = [...logs];
        this.customersLog = this.adaptLogsByCompany(logs);
        this.tableHeaders = Array.from(Object.keys(_.groupBy(this.customersLog, 'hour')));

        Object.keys(this.groupedDataSource['company']).map(
          (companyName) => {
            const item: ICompanyListItem = {
              name: companyName,
              selected: false,
            };
            this.listCompanies = [...this.listCompanies, item];
          }
        );
        this.gettingCompanies = false;

        // actualizar la informacion mostrada en el resumen
        this.updateSummaryData();
      }, (err) => {
        console.log(err);
      });

      // preparar la informacion completa para generar el GRAFICO #2
      this.processInfoChart2(this.dataSource);
    }
  }

  private adaptLogsByCompany(logs: []) {
    let auxLogs = [];
    let finalLogs = [];

    this.companiesAllowed.map((company: ICompany) => {
      auxLogs = [...auxLogs, logs.filter(log => log['company_name'] === company.name)];
    });

    auxLogs.map((data) => {
      finalLogs = finalLogs.concat(data);
    });

    return finalLogs;
  }

  // updateCheckSelected() {
  //   // entra aca solo cuando clickea sobre el check activar/desativar todas...
  //   if (typeof this.matcompanies.options !== 'undefined') {
  //     const options = Array.from(this.matcompanies.options._results);
  //     options.map(
  //       (option: MatListOption) => {
  //         option.selected = this.checkedAll;
  //       }
  //     );
  //   }
  // }

  openDetails(event, chart) {
    // const selected = this.chart.getElementAtEvent(event)[0];
    const activePoint = chart.getElementsAtEvent(event)[0];
  }

  private getValues(data: object, companyName: string, companies: object) {
    let values = [];

    Object.keys(data).map((hour) => {
      const itemHour = data[hour] as [];
      const totalThisHour = itemHour.filter((item) => {
        return item['company_name'] === companyName;
      });
      values = [...values, (totalThisHour.length ? totalThisHour[0]['total'] : 0)];
    });

    return values;
  }

  private processInfoChart2(dataSource: []) {
    const dataGroupedBy = {
      company: _.groupBy(dataSource, 'company_name'),
      hour: _.groupBy(dataSource, 'hour'),
    };
    this.groupedDataSource = dataGroupedBy;

    let rgbs = [];
    let borders = [];
    let labels = [];

    Object.keys(dataGroupedBy.hour).map((hour) => {
      const tempRgb = COLORS.GENERATE_COLOR();
      rgbs = [...rgbs, `rgb(${tempRgb.r}, ${tempRgb.g}, ${tempRgb.b}, 0.6)`];
      borders = [...borders, COLORS.FULL_COLOR_HEX(tempRgb)];
      labels = [...labels, hour];
    });

    Object.keys(dataGroupedBy.company).map((company, i) => {
      const chartDataset: IChartDataset = {
        label: company,
        backgroundColor: rgbs[i],
        borderColor: borders[i],
        borderWidth: 0.5,
        data: this.getValues(dataGroupedBy.hour, company, dataGroupedBy.company),
        fill: true,
      };
      this.datasets = [...this.datasets, chartDataset];
    });

    // crear una copia de los datasets para interactuar...
    this.auxDatasets = this.datasets.map(item => item);

    const chartData: IChartData = {
      labels: labels,
      datasets: this.datasets,
    };
    const chartInfo2 = {
      type: 'bar',
      data: chartData,
      options: {
        title: {
          display: false,
          text: 'chart - stacked'
        },
        // hover: {
        //   mode: 'nearest',
        //   intersect: true,
        // },
        // tooltips: {
        //   mode: 'index',
        //   intersect: false
        // },
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              callback: function(value, index, valuess) {
                return value + ' Hrs.';
              }
            },
            scaleLabel: {
              display: true,
              labelString: 'Empresas'
            }
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
            },
            scaleLabel: {
              display: true,
              labelString: 'Cantidad'
            }
          }]
        }
      }
    };

    this.chart2 = new Chart('chart-object2', chartInfo2);
  }

  private getInfoCustomers(companyName: string) {
    let auxArray: [] = [];
    this.filteredCustomersLog = this.customersLog.filter((item) => item['company_name'] === companyName);

    const groupedByCustomer = _.groupBy(this.filteredCustomersLog, 'full_name');

    // iterar los usuarios con actividad en la app para la empresa seleccionada...
    Object.keys(groupedByCustomer).map((customer) => {

      // iterar sobre cada hora ...
      let auxActivities = [];
      Object.keys(this.groupedDataSource['hour']).map((hour) => {
        const found = this.filteredCustomersLog.filter(
          (item) => (parseInt(item['hour'], 10) === parseInt(hour, 10) && item['full_name'] === customer)
        );
        auxActivities = [...auxActivities, (found.length > 0)];
      });
      const auxItem = {
        customer: customer,
        company: companyName,
        activity: auxActivities,
      };

      // agregar la actividad completa a la lista...
      auxArray = [...auxArray, auxItem] as [];
    });

    return auxArray;
  }

  private mergeLogArrays(arrayLogs: [][]) {
    let logs = [];
    let mergedArrays = [];

    arrayLogs.map((item) => {
      logs = [...logs, item];
    });

    logs.map((item) => {
      const auxArray = mergedArrays;
      mergedArrays = auxArray.concat(item);
    });

    return mergedArrays;
  }

  private mergeSelectedCompanies(arrayCompanies: ICompanyListItem[]) {
    let logs = [];
    let mergedArrays = [];

    arrayCompanies.map((company: ICompanyListItem) => {
      logs = [...logs, this.getInfoCustomers(company.name)];
    });

    logs.map((companyArrayLog) => {
      const auxArray = mergedArrays;
      mergedArrays = auxArray.concat(companyArrayLog);
    });

    return mergedArrays;
  }

  updateSummaryData() {
    let mergedArrays = [];
    const auxTotals = [...this.totalConnections];
    // this.checkedAllSubject.next(this.checkedAll);

    if (this.checkedAll) {
      this.matcompanies.selectAll();
      mergedArrays = this.mergeSelectedCompanies(this.listCompanies);

      // para el grafico #2...
      this.auxDatasets = this.datasets.map(item => item);
    } else {
      this.matcompanies.deselectAll();

      // para el grafico #1...
      auxTotals.map((value: number, i) => auxTotals[i] = 0);

      // para el grafico #2...
      this.auxDatasets = [];
    }

    // aplicar los cambios en el grafico #1...
    this.data.datasets[0].data = auxTotals;
    this.chart1.update();

    // aplicar los cambios en el grafico #2...
    this.chart2['data']['datasets'] = this.auxDatasets;
    this.chart2.update();
    this.summaryData = mergedArrays as [];
  }
}
